<template>
    <div>
        <work-history-item   v-for="(workHistoryData, i) in workHistoriesData" :key="i" :workHistoryData="workHistoryData"/> 
    </div>
</template>

<script>
import { ratingClient } from "../../../../../api/config.js";
import WorkHistoryItem from "./items/WorkHistoryItem.vue";
export default {
    name: "WorkHistories",
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    components: {
        WorkHistoryItem
    },
    data(){
        return {
            workHistoriesData: [],
        }
    },
    mounted(){
        if (this.data){
            let params = {
                "applicationId": this.data.id,
                "page": 1,
                "size": 20
            }
            ratingClient.fetchAllOfPage(params).then((res) => {
                if (!res.networkError){
                    if (res.status == 200){
                        console.log(res.body.list);
                        this.workHistoriesData = res.body.list;
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>